(function() {
    angular
        .module("apiModule")
        .controller("ApiDocsController", ApiDocsController)

        ApiDocsController.$inject = [
        "$rootScope",
        "$state",
        "$stateParams",
        "userMessagingService",
        "apiService"
    ]

    function ApiDocsController(
        $rootScope,
        $state,
        $stateParams,
        userMessagingService,
        apiService
    ){
        "use strict"

        if (!$rootScope.can('ApiGeneralRead', $stateParams.customer_id)) {
            $state.go("devices")
        }

        $rootScope.title = "API Documentation | WANCO"

        const mask = document.createElement("div")
        mask.id = "mask"
        mask.style.cssText = "position: absolute; margin: 0px; padding: 0px; top:0px; left:0px; width: 100%; height: 100%; background-color: #FFF; z-index: 99999;"
        document.body.appendChild(mask)

        const success = (data) => {
            if (data.hasOwnProperty("html")) {
                document.getElementsByTagName("html")[0].innerHTML = data.html

                let script = document.createElement("script")
                script.type = "text/javascript"
                script.src = "/api/docs/javascripts/all.js"

                document.head.appendChild(script)

                setTimeout(() => {
                    window.Gifffer()
                }, 200)

            } else {
                failure()
            }
        }

        const failure = () => {
            document.getElementById("mask").outerHTML = ""
            $state.go("api", { customer_id: $stateParams.customer_id, api_config_id: $stateParams.api_config_id }, { reload: false }).then(() => { userMessagingService.error("Failed to retrieve Documentation") })
        }

        apiService.getDocs($stateParams.customer_id, $stateParams.api_config_id, $stateParams.group, $stateParams.section, $stateParams.format, success, failure)

    }
})()
